module.exports = __webpack_public_path__ + "99d6999768c52698d37e5f2062113ea6.svg";